import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { SiteHeader } from "../components/SiteHeader";
import { ApiError, apiFetch } from "../api/client";
import { authEntryPathForError } from "../lib/authRedirect";

export function AcceptInvitePage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get("t")?.trim() ?? "";
  const [status, setStatus] = useState<"loading" | "ok" | "error">("loading");
  const [message, setMessage] = useState("Принимаем приглашение…");

  useEffect(() => {
    if (!token) {
      setStatus("error");
      setMessage("Нет токена приглашения. Откройте ссылку из письма полностью.");
      return;
    }

    void (async () => {
      try {
        const data = await apiFetch<{
          kind?: "board" | "folder";
          boardId?: string;
          folderId?: string;
          openPath?: string;
        }>("/api/v1/invitations/accept", { method: "POST", json: { token } });
        setStatus("ok");
        setMessage(
          data.kind === "folder"
            ? "Приглашение принято. Переход в папку…"
            : "Приглашение принято. Переход на доску…"
        );
        window.setTimeout(() => {
          navigate(
            data.openPath ||
              (data.kind === "folder" && data.folderId
                ? `/cabinet?section=shared&folder=${encodeURIComponent(data.folderId)}`
                : `/board/${data.boardId}`),
            { replace: true }
          );
        }, 600);
      } catch (e) {
        if (e instanceof ApiError && e.status === 401) {
          navigate(authEntryPathForError(e, `/invite/accept?t=${token}`), {
            replace: true,
          });
          return;
        }
        setStatus("error");
        setMessage(e instanceof Error ? e.message : "Не удалось принять приглашение");
      }
    })();
  }, [token, navigate]);

  return (
    <>
      <SiteHeader
        right={
          <Link className="wb-btn wb-btn--ghost wb-btn--sm" to="/cabinet">
            Кабинет
          </Link>
        }
      />
      <main className="wb-page wb-page--narrow wb-page--center">
        <h1 className="wb-page__title">Приглашение</h1>
        {status === "loading" ? (
          <p className="wb-page__lead">
            <span className="wb-spinner" aria-hidden />
            {message}
          </p>
        ) : status === "ok" ? (
          <p className="wb-form-ok">{message}</p>
        ) : (
          <>
            <p className="wb-form-error">{message}</p>
            <p className="wb-page__lead">
              Убедитесь, что вы вошли под тем email, на который пришло приглашение.
            </p>
            <p>
              <Link className="wb-btn wb-btn--primary" to="/login">
                Войти
              </Link>{" "}
              <Link className="wb-btn wb-btn--ghost" to="/cabinet">
                В кабинет
              </Link>
            </p>
          </>
        )}
      </main>
    </>
  );
}
